import { motion } from "framer-motion";
import HeroEligibilityCard from "@/components/HeroEligibilityCard";

const LINES = [
  "Rinnai heat pump hot water,",
  "installed by local licensed plumbers.",
];

const BG_IMAGE_DESKTOP =
  'image-set(url("/images/hero-rinnai-left-hd.webp") type("image/webp"), url("/images/hero-rinnai-left-hd.jpg") type("image/jpeg"))';
const BG_IMAGE_MOBILE =
  'image-set(url("/images/hero-rinnai-left-mobile-hd.webp") type("image/webp"), url("/images/hero-rinnai-left-mobile-hd.jpg") type("image/jpeg"))';
const OVERLAY_FORM =
  "linear-gradient(90deg, rgba(1,18,48,0.15) 0%, rgba(1,18,48,0.10) 30%, rgba(1,18,48,0.55) 55%, rgba(1,18,48,0.80) 100%)";
const OVERLAY_BOTTOM =
  "linear-gradient(0deg, rgba(1,18,48,0.85) 0%, rgba(1,18,48,0) 40%)";
const OVERLAY_MOBILE =
  "linear-gradient(180deg, rgba(1,18,48,0.55) 0%, rgba(1,18,48,0) 20%, rgba(1,18,48,0) 60%, rgba(1,18,48,0.35) 100%)";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative bg-navy overflow-hidden h-[calc(100svh-52px)] md:h-[calc(100vh-76px)] md:min-h-[640px]"
    >
      {/* Mobile (<768px): full-screen photo */}
      <div aria-hidden="true" className="absolute inset-0 md:hidden">
        <div
          data-testid="hero-bg-photo-mobile"
          className="absolute inset-0 bg-no-repeat"
          style={{
            backgroundImage: BG_IMAGE_MOBILE,
            backgroundSize: "cover",
            backgroundPosition: "45% 70%",
            backgroundColor: "#011B47",
          }}
        />
        <div
          className="absolute inset-0"
          style={{ background: OVERLAY_MOBILE }}
        />
      </div>

      {/* Desktop (>=768px): full-bleed photo + headline bottom-left */}
      <div className="hidden md:block absolute inset-0">
        <div
          aria-hidden="true"
          data-testid="hero-bg-photo"
          className="absolute inset-0 bg-no-repeat"
          style={{
            backgroundImage: BG_IMAGE_DESKTOP,
            backgroundSize: "cover",
            backgroundPosition: "20% 60%",
            backgroundColor: "#011B47",
          }}
        />
        <div
          aria-hidden="true"
          data-testid="hero-bg-overlay"
          className="absolute inset-0 pointer-events-none"
          style={{ background: OVERLAY_FORM }}
        />
        <div
          aria-hidden="true"
          data-testid="hero-bg-bottom-fade"
          className="absolute inset-0 pointer-events-none"
          style={{ background: OVERLAY_BOTTOM }}
        />
        <div className="absolute left-0 bottom-0 z-10 p-12 max-w-[560px]">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            data-testid="hero-eyebrow"
            className="text-[12px] font-bold uppercase tracking-[0.2em] text-[#8FD67A]"
          >
            Making home electrification simple
          </motion.p>
          <h1
            data-testid="hero-headline"
            className="mt-2.5 font-serif font-bold text-white tracking-tight text-[34px] leading-[1.12]"
          >
            {LINES.map((line, i) => (
              <span key={i} className="block overflow-hidden pb-1 -mb-1">
                <motion.span
                  className="block"
                  initial={{ y: "110%" }}
                  animate={{ y: 0 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.15 + i * 0.12,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                >
                  {line}
                </motion.span>
              </span>
            ))}
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.55 }}
            data-testid="hero-subheadline"
            className="mt-2.5 text-[15px] text-white/90"
          >
            Rebates handled. Most installs done in one day.
          </motion.p>
        </div>
      </div>

      {/* Mobile: headline top-left over the photo */}
      <div className="md:hidden relative z-10 pt-3 px-4">
        <h1
          data-testid="hero-headline-mobile"
          className="font-serif font-bold text-white text-[20px] leading-[1.15]"
          style={{ textShadow: "0 2px 10px rgba(0,0,0,0.4)" }}
        >
          Rinnai heat pumps, installed by local plumbers.
        </h1>
        <p
          data-testid="hero-subheadline-mobile"
          className="mt-1 text-[11px] font-semibold text-[#8FD67A]"
        >
          Rebates handled · Most installs done in 1 day
        </p>
      </div>

      {/* Form card — bottom of screen on mobile, centred right on desktop */}
      <div
        data-testid="hero-form-card-wrapper"
        className="absolute z-10 bottom-[10px] left-[10px] right-[10px] md:bottom-auto md:left-auto md:right-14 md:top-1/2 md:-translate-y-1/2 md:w-[600px]"
      >
        <HeroEligibilityCard />
      </div>
    </section>
  );
};

export default Hero;
